import { createSelector } from '@reduxjs/toolkit';
import { getIsBot, getIsResponderAI } from 'conversations-internal-schema/responders/operators/responderGetters';
import { getId } from '../operators/responderKeyGetters';
import { getResponders } from './getResponders';
export const getHumanAgentSenderIds = createSelector([getResponders], respondersMap => {
  const humanIds = [];
  respondersMap.forEach((responder, key) => {
    if (!getIsBot(responder) && !getIsResponderAI(responder)) {
      humanIds.push(String(getId(key)));
    }
  });
  return humanIds.sort().join(',');
});